<button (click)="showCollectorDialog()"
        class="trigger primary -vertical"
        color="primary"
        mat-raised-button
        type="button">
  {{text}}
</button>
